<div class="row" *ngIf="chatdata.SubmitFeedback">
    <div class="feed-back-section">
      <p class="m-t-0 m-b-10">{{ 'UNLIKE_FEEDBACK_TITLE_TEXT' | translate }}</p>
      <div class="row">
        <ul class="feedback-list">
          <li *ngFor="let item of chatdata.FeedbackOptions; let k = index">
            <input
              type="checkbox"
              id="control_{{item.pk_chathistoryid}}_{{item.Id}}"
              name="select_{{item.pk_chathistoryid}}_{{item.Id}}"
              [value]="item.Id"
              [(ngModel)]="item.IsChecked"
            />
            <label for="control_{{item.pk_chathistoryid}}_{{item.Id}}">
              {{
              (item.Name === 'Incorrect Response' ? 'UNLIKE_FEEDBACK_LABEL_1' :
                item.Name === 'Incorrect References' ? 'UNLIKE_FEEDBACK_LABEL_2' :
                item.Name === 'Missing Information' ? 'UNLIKE_FEEDBACK_LABEL_3' :
                item.Name === 'Irrelevant' ? 'UNLIKE_FEEDBACK_LABEL_4' :
                item.Name === 'Partially Correct Response' ? 'UNLIKE_FEEDBACK_LABEL_5' :
                item.Name) | translate 
              }}
            </label>
          </li>
        </ul>
      </div>
  
      <div class="row display-inline-block">
        <div class="form-group m-t-10">
          <label for="additionalComments" class="label">{{'ADDITIONAL_COMMENTS_TEXT' | translate}}</label>
          <textarea
            id="additionalComments"
            class="form-control"
            [(ngModel)]="chatdata.AdditionalComments"
            cols="3"
            placeholder="{{'ADDITIONAL_COMMENTS_PLACEHOLDER' | translate}}"
          ></textarea>
          <span
            *ngIf="!isAnyOptionChecked(chatdata.FeedbackOptions) && chatdata.ErrorMsg"
            class="error_message"
          >
            {{'ATLEAST_ONE_OPTION_TOASTER_MSG' | translate}}
          </span>
        </div>
      </div>
  
      <div class="row display-inline-block">
        <div class="form-group m-t-20 text-right pull-right">
          <a href="#" class="btn btn-secondary-outline" (click)="handleClear()">{{'CANCEL_BUTTON_TEXT' | translate}}</a>
          <a href="#" class="btn btn-primary m-l-10" (click)="handleSubmit()">{{'SUBMIT_BUTTON_TEXT' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
  